var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{class:_vm.className,attrs:{"id":_vm.id,"type":"file","accept":_vm.accept,"capture":_vm.capture,"multiple":_vm.multiple,"hidden":_vm.hidden},on:{"change":_vm.uploadFile}}),_vm._t("upload-label")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }